module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Fireplace-46e5641e0885b7730435f833dd453770.svg";